import React, { useEffect, useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { InfoIcon } from "../../../constants/icons";
import "./ListingDetailBlockItem.css";
const ListingDetailBlockItem = ({ item }) => {
    useEffect(()=>{
        console.log("use item",item)
    },[item])

    return (
            <div className="table-details-block-box-content-col2-row2 table-shadow-box">
                <div className="table-details-block-box-content-col1-col1">
                    <p>{item?.title}{item?.tooltip?<span className={"item-info-tooltip"} data-tooltip-html={item?.tooltip}><InfoIcon /></span>:""}</p>
                </div>
                <div className="table-details-block-box-content-col1-col2">
                    {
                        (item?.link)?
                            <a href={item?.url} target={"_blank"}>
                                <p>{item?.value}</p>
                            </a>
                        :
                        <p>{item?.value}</p>
                    }
                </div>
            </div>
        )
}

export default ListingDetailBlockItem;
